// import i18nFunctions from "client/utils/i18n";
import FireBase from "client/services/fireBase/apis";
import handlers from "client/utils/fireBase/cloudFunctions/handlers";
import { fireBaseAnalytics } from "client/services/fireBase/firebaseConfig";

const onPageInit = async (props) => {
  // const { i18n } = i18nFunctions;
  const { dataExists, currentUser, courseName } = props;

  const onPageInitProps = {};

  if (!dataExists) {
    const courses = await FireBase.getCourses();
    if (Array.isArray(courses) && courses.length !== 0) {
      const selectedCourse = courses.filter(
        (course) => course.courseTitle === courseName
      );
      onPageInitProps["selectedCourse"] = selectedCourse;
    }

    const userProgress = await FireBase.getUserProgress({ currentUser });
    const { userData: progressData } = userProgress[0];
    onPageInitProps["progressData"] = progressData;
  }
  return onPageInitProps;
};

const onProgressChange = async (props) => {
  const { currentUser, currentProgress, selectedCourse, videoId } = props;

  const newProgress = await handlers.updateProgressData(
    currentUser,
    currentProgress,
    selectedCourse,
    videoId
  );

  const updateProgressResponse = await FireBase.updateProgress({
    currentUser,
    newProgress,
  }).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content;
    }
    return [];
  });

  const updatedProgressData = updateProgressResponse[0]?.userData;

  return updatedProgressData;
};

const onSubmit = (props) => () => {
  fireBaseAnalytics.logEvent("courses_visited_back");
};

const functions = { onPageInit, onProgressChange, onSubmit };

export default functions;
